module.exports = __webpack_public_path__ + "kg.svg?20cdf6156992570d17d7e923af3dd9d9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/kg.svg
// module id = 1441
// module chunks = 0